import { Injectable } from '@angular/core';
import { EIndustry } from '../../enums/industry.enum';

@Injectable()
export class IndustriesService {
  /**
   * Retrieves a list of industries from the EIndustry enum and transforms them into a formatted array of strings.
   * @returns {string[]} An array of formatted industry names.
   */
  public getIndustriesList(): string[] {
    return Object.keys(EIndustry).map((key) =>
      key.replace(/_/g, ' ').replace(/AND/g, '&').toUpperCase()
    );
  }
}
